import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './navbar.css';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleScroll = () => {
    const offset = window.scrollY;
    if (offset > 50) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className={`navbar ${scrolled ? 'scrolled' : ''} ${isOpen ? 'navbar-expanded' : ''}`}>
      <div className="navbar-container">
        <div className="logo" onClick={() => setIsOpen(false)}>CodeAkram.</div>
        <nav className={`nav-links ${isOpen ? 'open' : ''}`}>
          <Link to="/" onClick={() => setIsOpen(false)}>Home</Link>
          <Link to="/Skills" onClick={() => setIsOpen(false)}>Skills</Link>
          <Link to="/Designs" onClick={() => setIsOpen(false)}>Designs</Link>
          <Link to="/Projects" onClick={() => setIsOpen(false)}>Projects</Link>
          <Link to="/Services" onClick={() => setIsOpen(false)}>Services</Link>
          <Link to="/Contact" onClick={() => setIsOpen(false)}>Contact</Link>
        </nav>
        <div className={`menu-icon ${isOpen ? 'open' : ''}`} onClick={toggleMenu}>
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </div>
      </div>
    </header>
  );
}

export default Navbar;
